import { useEffect, useState } from 'react'
import { ref, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'

// Light role-based permissions. There is no per-user auth in this app, so the
// "current employee" is a per-browser-session selection (Settings / top bar).
// Roles rank: staff < manager < owner. Sensitive sections gate on rank.
export const ROLES = ['staff', 'manager', 'owner']
export const ROLE_RANK = { staff: 1, manager: 2, owner: 3 }
const KEY = 'gg_current_employee'

export function getCurrentEmployeeId() {
  try { return sessionStorage.getItem(KEY) || null } catch { return null }
}
export function setCurrentEmployeeId(id) {
  try { id ? sessionStorage.setItem(KEY, id) : sessionStorage.removeItem(KEY) } catch {}
  window.dispatchEvent(new Event('gg-employee-changed'))
}

// Hook: resolves the current employee record (from /club/employees) + role.
// Defaults to owner when nobody is selected, so the suite is fully usable
// before Employees are set up (permissions are a soft guard, not a lockout).
export function useCurrentRole() {
  const [id, setId] = useState(getCurrentEmployeeId())
  const [employees, setEmployees] = useState({})
  useEffect(() => {
    const onChange = () => setId(getCurrentEmployeeId())
    window.addEventListener('gg-employee-changed', onChange)
    const off = onValue(tref('club/employees'), (s) => setEmployees(s.val() || {}))
    return () => { window.removeEventListener('gg-employee-changed', onChange); off() }
  }, [])
  const emp = id ? employees[id] : null
  const role = emp?.role || 'owner'
  const can = (minRole) => (ROLE_RANK[role] || 3) >= (ROLE_RANK[minRole] || 1)
  return { employeeId: id, employee: emp, role, can }
}
